import { ButtonBase, Grid, GridSize, Typography } from '@material-ui/core';
import { colors } from 'design-system';
import React from 'react';
import { Bell, LogOut } from 'react-feather';
import makeDashboardToolbarStyles from './makeDashboardToolbarStyles';

type ClassesType = ReturnType<typeof makeDashboardToolbarStyles>;

/**
 * Notification icon for mobile
 */
export const mobileBell = (
  <Grid item xs={4} container justifyContent="flex-start">
    <Bell color={colors.white} />
  </Grid>
);

/**
 * Assa logo for mobile
 */
export const mobileAssaLogo = (
  <Grid item xs={4} container justifyContent="center">
    <img src="./svg/white_assa_logo.svg" alt="logo" height={30} />
  </Grid>
);

/**
 * Makes the logout button from mobile.
 *
 * @param handleLogout - Called when the logout is requested
 * @param classes - Classes generated by useStyles
 */
export function makeLogoutButtonMobile(
  handleLogout: (isBackToAssanet: boolean) => void,
  classes: ClassesType,
  showText = true,
): React.ReactNode {
  return (
    <Grid item xs={4} container justifyContent="flex-end">
      <ButtonBase
        id="sales-web-button-logout"
        data-testid="logout-mobile"
        onClick={(): void => handleLogout(false)}
      >
        <Grid container alignItems="center">
          <LogOut color={colors.white} size={20} />
          {showText && (
            <>
              &nbsp;
              <Typography variant="caption" className={classes.appBarText}>
                Salir
              </Typography>
            </>
          )}
        </Grid>
      </ButtonBase>
    </Grid>
  );
}

/**
 * Generates welcome layout for the current user.
 *
 * @param user - The current user name
 * @param classes - Classes generated by useStyles
 */
export function makeUserLayoutMobile(
  user: string,
  classes: ClassesType,
  xs: GridSize = 6,
): React.ReactNode {
  return (
    <Grid item xs={xs}>
      <Typography
        data-testid="mobile-user"
        variant="caption"
        className={classes.appBarText}
      >
        ¡Hola {user}!
      </Typography>
    </Grid>
  );
}
